export default {
    accounts: []
};